<template>
  <div class="radio-buttons" :class="{bordered}">
    <div v-for="option in options" :key="option.value" class="button-container">
      <md-button
        v-testid="`${option.label}-radio-button`"
        class="md-raised bg"
        :class="buttonClasses(option)"
        :aria-label="option.label"
        :disabled="disabled || option.disabled"
        @click="(event) => select(option.value, event)"
      >
        {{ option.label }}
      </md-button>
      <md-tooltip v-show="option.tooltip">
        {{ option.tooltip }}
      </md-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  name: 'radio-buttons',
  props: {
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: [String, Number, Boolean, Array],
      default: null,
    },
    activeColor: {
      type: String,
      default: 'blue-6',
    },
    inactiveColor: {
      type: String,
      default: 'gray-5',
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    compact: {
      type: Boolean,
      default: false,
    },
    pillShaped: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    select(value, event) {
      event.stopPropagation();
      if (this.multiple) {
        this.$emit(
          'input',
          this.isActive(value)
            ? this.value.filter(v => v !== value)
            : this.value.concat(value),
        );
      } else {
        this.$emit('input', value);
      }
    },
    isActive(value) {
      if (this.multiple) {
        return this.value.includes(value);
      }
      return this.value === value;
    },
    buttonClasses(option) {
      const classArray = [];
      if (this.isActive(option.value)) {
        classArray.push(`${option.activeColor || this.activeColor} active`);
      } else {
        classArray.push(option.inactiveColor || this.inactiveColor);
      }
      if (this.compact) {
        classArray.push('md-button-compact');
      }
      if (this.pillShaped) {
        classArray.push('md-button-pill');
      }
      return classArray;
    }
  },
};
</script>

<style scoped>
.radio-buttons {
  display: inline-block;
}

.button-container {
  display: inline-block;
}

.md-button {
  border-radius: 0;
  margin: 0;
  border-right: solid 1px #fff;
  text-transform: initial;
}

.md-button[disabled] {
  color: lightgray !important;
}

.md-button-compact {
  min-width: 36px;
}

.radio-buttons:not(.bordered) .md-button {
  box-shadow: none !important;
}

.button-container:first-child .md-button {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}

.button-container:last-child .md-button {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border-right: none;
}

.button-container:first-child .md-button-pill {
  border-top-left-radius: 40px;
  border-bottom-left-radius: 40px;
}

.button-container:last-child .md-button-pill {
  border-top-right-radius: 40px;
  border-bottom-right-radius: 40px;
}
</style>

<style>
.radio-buttons .md-button-content {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  height: 100%;
}
</style>